import { render } from "./ProductCardPage.vue?vue&type=template&id=709d7489&scoped=true"
import script from "./ProductCardPage.vue?vue&type=script&lang=js"
export * from "./ProductCardPage.vue?vue&type=script&lang=js"

import "./ProductCardPage.vue?vue&type=style&index=0&id=709d7489&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709d7489"]])

export default __exports__